const value = Object.freeze({
  Regular: 1,
  Validation: 5,
  Appraisal: 6,
  EquipmentRelatedServiceRequest: 7,
  TechnicalAssistanceServiceRequest: 8,
});
export default value;
